import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CompanyComponent from "../components/CompanyComponent";
import CompanyContainer from "../CompanyContainer";
import franchiseIcon from "../../../assets/design-revamp-company/franchise-component/franchise-icon.svg";
import { addFranchiseToBusiness } from "../../../apis/Business/FranchiseApi";
import Franchise from "../Franchise";

const AddFranchise = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const [franchiseName, setFranchiseName] = useState("");
  const [franchiseHolder, setFranchiseHolder] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [countryOrigin, setCountryOrigin] = useState("");
  const [scope1, setScope1] = useState("");
  const [scope2, setScope2] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (year == null || year === "") {
      navigate("/company");
    }
  }, [navigate, year]);

  const handleFormDataChange = (updatedFormData) => {
    setFranchiseName(updatedFormData.franchiseName);
    setFranchiseHolder(updatedFormData.franchiseHolder);
    setVatNumber(updatedFormData.vatNumber);
    setCountryOrigin(updatedFormData.countryOrigin);
    setScope1(updatedFormData.scope1);
    setScope2(updatedFormData.scope2);
  };

  const save = () => {
    addFranchiseToBusiness({
      name: franchiseName,
      franchise_holder: franchiseHolder,
      vat_num: vatNumber,
      country: countryOrigin,
      setErrorMessage: setErrorMessage,
      scope_1: scope1,
      scope_2: scope2,
      use_swal: true,
      callback: () =>
        setTimeout(() => {
          window.location.reload();
        }, 1000),
    });
  };

  const handleSave = () => {
    save();
    return;
  };

  return (
    <CompanyContainer>
      <div
        className="companydetail"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingRight: "42px",
          marginBottom: "94.45px",
        }}
      >
        <CompanyComponent
          name={franchiseName}
          address_line_1={countryOrigin}
          iconComponent={franchiseIcon}
        />
        <Franchise
          initialData={{
            franchiseName,
            franchiseHolder,
            vatNumber,
            countryOrigin,
            scope1,
            scope2,
          }}
          isNewFacility={true}
          onFormDataChange={handleFormDataChange}
          handleSave={handleSave}
          errorMessage={errorMessage}
          setCurrentName={setFranchiseName}
          setCutOffAddress={setCountryOrigin}
        />
      </div>
    </CompanyContainer>
  );
};

export default AddFranchise;
